"use client";

import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { SectionLoggingEventParams } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { cn } from "@faire/web/tools/cn";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import React from "react";

const CATEGORY_GRID_CLASS = "lg:grid-cols-[276px_minmax(0,1fr)]";
const SEARCH_GRID_CLASS =
  "lg:grid-cols-[1fr_minmax(0,4fr)] xl:grid-cols-[1fr_minmax(0,5fr)]";

export const SDUIFPSRendererWithCollapsibleSidebarWrapper: React.FC<{
  sectionLoggingData: SectionLoggingEventParams;
  children: React.ReactNode;
}> = ({ sectionLoggingData, children }) => {
  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);

  const isCategoryPage =
    sectionLoggingData.view_display_page === DisplayPageType.CATEGORY_PAGE;

  const withVisibleSidebar = isCategoryPage
    ? CATEGORY_GRID_CLASS
    : SEARCH_GRID_CLASS;

  return (
    <div
      className={cn(
        "grid",
        isSideBarVisible
          ? withVisibleSidebar
          : "lg:grid-cols-[0px_minmax(0,1fr)]"
      )}
    >
      {children}
    </div>
  );
};
